// @flow
import { connect } from 'react-redux';

import TeamMenuNextMatch from 'components/teammenu/TeamMenuNextMatch';
import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/teammenu/TeamMenuNextMatch';

export default connect((state: StateType): StateProps => ({
  userPref: state.userState.userPref,
  //parionsSportCote: state.settingsState.parionsSportCote
}))(TeamMenuNextMatch);
